import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import { OverlayView } from "@react-google-maps/api"
import { Button, Flex, Tag } from "antd"
import { numberToCurrency } from "helpers/string"
import { tripPrice } from "./utils"
import styles from "./TripMapCluster.module.css"
import { Text } from "ui/Typography"

const TripMapCluster = ({ trips, hoverItemId, activeItemId, toggle }) => {
  const [open, setOpen] = useState(false)
  const containerRef = useRef(null)

  const hasActiveMember = trips.some((trip) => trip.id === activeItemId)

  useEffect(() => {
    if (!open) return
    const handleOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) setOpen(false)
    }
    window.addEventListener("mousedown", handleOutside)
    return () => window.removeEventListener("mousedown", handleOutside)
  }, [open])

  const position = { lat: trips[0].latitude, lng: trips[0].longitude }

  const selectHandler = (id) => (event) => {
    event.stopPropagation()
    typeof toggle === "function" && toggle(id)
  }

  const toggleHandler = (event) => {
    event.stopPropagation()
    setOpen((prev) => !prev)
  }

  return (
    <OverlayView
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      position={position}
      getPixelPositionOffset={(width, height) => ({ x: width / -2, y: height / -2 })}
    >
      <div ref={containerRef} className={styles.cluster} style={{ zIndex: open ? 3 : 1 }}>
        {!hasActiveMember && (
          <Flex gap={4} align="center">
            <Tag bordered={false} className={styles.clusterToggle} onClick={selectHandler(trips[0].id)}>
              {numberToCurrency(tripPrice(trips[0]))}
            </Tag>
            <Button size="small" color="primary" variant="outlined" className={`px-2 ${styles.clusterButton}`} onClick={toggleHandler}>
              + {trips.length}
            </Button>
          </Flex>
        )}

        {open && (
          <div className={`cluster-popover ${styles.popover}`}>
            <div className={styles.popoverHeader}>{trips.length} experiences here</div>
            <ul className={styles.list}>
              {trips.map((trip) => (
                <li key={trip.id}>
                  <button
                    type="button"
                    className={[
                      styles.row,
                      hoverItemId === trip.id || activeItemId === trip.id ? styles.rowActive : ""
                    ].join(" ")}
                    onClick={selectHandler(trip.id)}
                  >
                    <Text fw="600" className={styles.price}>
                      {numberToCurrency(tripPrice(trip))}
                    </Text>
                    <Text className={styles.title}>{trip.title}</Text>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </OverlayView>
  )
}

TripMapCluster.propTypes = {
  trips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
      title: PropTypes.string
    })
  ).isRequired,
  hoverItemId: PropTypes.string,
  activeItemId: PropTypes.string,
  toggle: PropTypes.func
}

export default TripMapCluster
